module.exports = __webpack_public_path__ + "assets/img/driver-btn-444d6750.png";